<template>
  <sr-loading></sr-loading>
</template>

<script>
export default {
  name: "ClassLink",
  created() {
    if (this.app_info.short_name == "ISP") {
      if (window.location.origin.includes("localhost")) {
        var route = { name: "Home" };
        this.$router.push(route);
      } else {
        var uri = `${window.location.origin}/app`;
        //var uri = `https://development.smartrubric.com/app`;
        console.log(uri);
        this.$login(uri, true);
      }
    }
  },
};
</script>
